import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { queryClient } from '../../../config/queryClient'
import { NotificationKeys } from '../../../enums/notificationKeys'
import { zervantSettingsQueryKey } from '../constants/zervantSettingsQueryKey'
import { useUpdateZervantSettings } from '../hooks/useUpdateZervantSettings'
import { useZervantSettings } from '../hooks/useZervantSettings'

export const useUpdateVatExemptionMention = () => {
  const { t } = useTranslation()
  const { data: zervantSettings, isLoading } = useZervantSettings()
  const { update, isProcessing } = useUpdateZervantSettings()

  const updateVatExemptionMention = (vatExemptionScheme: string, onSuccess?: () => void) => {
    if (!zervantSettings) {
      return
    }

    update(
      {
        values: {
          ...zervantSettings.values,
          company: {
            ...zervantSettings.values.company,
            legalMentions: {
              ...zervantSettings.values.company.legalMentions,
              custom: {
                ...zervantSettings?.values?.company?.legalMentions?.custom,
                vatExemptionScheme: vatExemptionScheme.trim() || null,
              },
            },
          },
        },
      },
      {
        onSuccess: () => {
          notify({
            id: NotificationKeys.ExternalInvoiceSettingsUpdate,
            message: t('settings.organization.external_invoice.general.vat_exemption_mention.modal.save.success'),
            variant: 'success',
          })
          queryClient.invalidateQueries(zervantSettingsQueryKey)
          onSuccess?.()
        },
        onError: () => {
          notify({
            id: NotificationKeys.ExternalInvoiceSettingsUpdate,
            message: t('error_saving'),
            variant: 'error',
          })
        },
      },
    )
  }

  return { update: updateVatExemptionMention, isProcessing, isLoading }
}
